/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import {
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid2,
} from '@mui/material';
import ChargeA from './ChargeA';
import ChargeB from './ChargeB';

export default function ComparativeCharges(props) {
  const { open, setOpen, meter } = props;
  const [showMainButton, setShowMainButton] = useState(true);
  const [infoA, setInfoA] = useState(null);
  const [infoB, setInfoB] = useState(null);

  return (
    <Dialog
      aria-labelledby="customized-dialog-title"
      fullWidth
      maxWidth="lg"
      open={open}
    >
      <DialogTitle
        id="customized-dialog-title"
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Chip
          label="Comparativo de Mediciones"
          size="medium"
          sx={{ bgcolor: '#a53693', color: 'white' }}
        />
      </DialogTitle>
      <DialogContent dividers={true}>
        <Grid2
          container={true}
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
        >
          <Grid2 size={5} alignItems="center">
            <ChargeA
              meters={meter}
              showMainButton={showMainButton}
              setInfoA={setInfoA}
              setInfoB={setInfoB}
            />
          </Grid2>
          <Grid2 size={5} alignItems="center">
            <ChargeB
              meters={meter}
              showMainButton={showMainButton}
              setInfoA={setInfoA}
              setInfoB={setInfoB}
            />
          </Grid2>
        </Grid2>
        {showMainButton && (
          <Button
            color="secondary"
            fullWidth
            disabled={infoA && infoB ? false : true}
            onClick={() => setShowMainButton(false)}
            type="button"
            variant="contained"
            sx={{ mt: 2 }}
          >
            Comparar Mediciones
          </Button>
        )}
      </DialogContent>
      <DialogActions>
        <Button
          color="secondary"
          onClick={() => {
            setOpen(false);
            setShowMainButton(true);
            setInfoA(null);
            setInfoB(null);
          }}
          type="button"
          variant="contained"
        >
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
